export const MAINTENANCE_PATH = "/warning-page/#/maintenance";
export const DISABLED_PORTAL_PATH = "/warning-page/#/disabled-portal";
